import { render, staticRenderFns } from "./GroupTrainings.vue?vue&type=template&id=e3e04478&scoped=true&"
import script from "./GroupTrainings.vue?vue&type=script&lang=js&"
export * from "./GroupTrainings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e04478",
  null
  
)

export default component.exports